import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import * as React from 'react';
import styled from 'styled-components';
import { DOLTypographyVariant, parseVariant, Typography } from '../../../DesignSystemV2/Typography';

const Wrapper = styled.div`
  position: relative;
`;
const HiddenLinkLayer = styled.a<{ fontSize: number }>`
  z-index: -1;
  display: block;
  font-size: ${(p) => p.fontSize || 20}px;
  color: rgba(255, 255, 255, 0.15);
  position: absolute;
  top: 0;
  white-space: nowrap;
`;

interface TextWithLinkProps {
  text?: string;
  content?: any;
  link: string;
  variant: DOLTypographyVariant;
  textStyle?: React.CSSProperties;
}

export const TextWithLinkPdfOriginal = ({
  text,
  content,
  variant = 'regular/20-32',
  link,
  textStyle,
}: TextWithLinkProps) => {
  const fontSizeForHiddenLayer = parseVariant(variant);
  return (
    <Wrapper className="custom-link-pdf">
      <div>
        {text ? (
          <Typography.Text variant={variant} style={textStyle}>
            {text}
          </Typography.Text>
        ) : (
          content
        )}
      </div>

      <HiddenLinkLayer
        href={getLandingUrlFromPath(link)}
        fontSize={fontSizeForHiddenLayer.fontSize}
      >
        <span>{getLandingUrlFromPath(link)}</span>
      </HiddenLinkLayer>
    </Wrapper>
  );
};
